import React, { useState, useEffect } from "react";
import { withNamespaces } from "react-i18next";
import {
  ToggleButton,
  ToggleButtonGroup,
  Grid,
  Paper,
  Button,
  Stack,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Pagination,
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import Axios from "axios";
import Select from "react-select";
import Sidebar from "../../sidebar/sidebar";
import { companylogo } from "../../../assets/images";
import { BaseUrl } from "../../../Environment";
import moment from "moment";
import { FilterAlt } from "@mui/icons-material";
import Customdaterange from "../../modals/customdaterange/customdaterange";
import { getSecureItem } from "../../../utilsFunctions";
import PdfReportDisburse from "./PdfReportDisburse";
import { getCompanyProfile } from "../../../api/index";
import excel from "../../../assets/images/excel.svg";
import pdf from "../../../assets/images/pdf.svg";
import { ExcelReport } from "../ExcelReport";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#e1f0fa",
    color: theme.palette.common.black,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    cursor: "pointer",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const loanTableHeader = {
  loanId: "Loan Id",
  firstName: "Borrower Name",
  areaLine: "Area/Line",
  loanAmount: "Lent Amount",
  processFee: "Processing Fee",
  installmentAmount: "Installment Amount",
  approvedDate: "Approved Date",
  disbursedDate: "Disbursed Date",
  firstDueDate: "First Due Date",
  assignedTo: "Assigned To",
};

const collectionTableHeader = {
  SrNo: "Sr. No.",
  dueDate: "Due Date",
  openingBalance: "Opening Balance",
  Installment: "Installment Amount",
  closingBalance: "Closing Balance",
};

const DisburseReport = () => {
  const loggedinUser = getSecureItem("loggedinUser");
  const columnWidths = [
    { wch: 200 },
    { wch: 200 },
    { wch: 250 }
  ]

  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loanTenure, setLoanTenure] = useState("All");
  const [page, setPage] = useState(1);
  const [userType] = useState(loggedinUser?.userType || "");
  const [startDateD, setStartDateD] = useState(null);
  const [endDateD, setEndDateD] = useState(null);
  const [fullReport, setFullReport] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branchData, setBranchData] = useState([]);
  const [loanData, setLoanData] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [totalSummary, setTotalSummary] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [loanId, setLoanId] = useState(null);
  const [collectionModal, setCollectionModal] = useState(false);
  const [selectedBorrower, setSelectedBorrower] = useState("");
  const [loanCollectionData, setLoanCollectionData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [datePickerM, setDatePickerM] = useState(false);
  const [exportType, setExportType] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  const [gotFullData, setGotFullData] = useState(false);

  const fullReportRef = React.useRef(false);

  const openFilter = Boolean(anchorElFilter);

  const setFullReportSync = (val) => {
    fullReportRef.current = val;
    setFullReport(val);
  };

  const handleClickFilter = (e) => setAnchorElFilter(e.currentTarget);
  const handleCloseFilter = () => setAnchorElFilter(null);

  const handleSortNew = (key) =>
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));

  const fetchBranches = async () => {
    try {
      const token = getSecureItem("token");
      const { data } = await Axios.get(`${BaseUrl}/branch/getAllBranches`, {
        params: { companyId: loggedinUser.companyId },
        headers: { Authorization: "Bearer " + token },
      });
      const branchList =
        loggedinUser?.userType === "superAdmin"
          ? data?.data
          : data?.data?.filter(
            (item) => item?.branchId === loggedinUser?.branchId,
          );
      setBranchData(
        branchList?.map((item) => ({
          label: item.branchName,
          value: item.branchId,
        })) || [],
      );
    } catch (err) {
      console.error("Fetch Branches Error:", err);
    }
  };

  const getLoansData = async () => {
    try {
      setLoading(true);
      const token = getSecureItem("token");
      const companyId = getSecureItem("loggedinUserCompany");
      const payLoad = {
        companyId,
        collectorId: loggedinUser?.userId,
        loanStatus: "Open",
        caFilter: false,
        loanTenureType: loanTenure,
        limit: 20,
        page,
        userType,
        startDateD,
        endDateD,
        fullReport: fullReportRef.current,
        branchId:
          loggedinUser?.userType === "superAdmin"
            ? selectedBranch?.value || ""
            : selectedBranch?.value || loggedinUser?.branchId || null,
      };
      const res = await Axios.post(
        `${BaseUrl}/loan/getLoanReport`,
        payLoad,
        {
          headers: { Authorization: "Bearer " + token },
        },
      );
      setLoanData(res?.data?.result || []);
      setTotalPages(Math.ceil((res?.data?.totalRecords || 0) / 20) || 1);

      if (fullReportRef.current) setGotFullData(true);

      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const getLoansSummary = async () => {
    try {
      const token = getSecureItem("token");
      const companyId = getSecureItem("loggedinUserCompany");
      const payLoad = {
        companyId,
        collectorId: loggedinUser?.userId,
        // loanStatus: "Open",
        caFilter: false,
        loanTenureType: loanTenure,
        limit: 20,
        page,
        userType,
        startDateD,
        endDateD,
        fullReport,
        branchId:
          loggedinUser?.userType === "superAdmin"
            ? selectedBranch?.value || ""
            : selectedBranch?.value || loggedinUser?.branchId || null,
      };
      const { data } = await Axios.post(
        `${BaseUrl}/loan/getLoansSummary`,
        payLoad,
        {
          headers: { Authorization: "Bearer " + token },
        },
      );
      setTotalSummary(data?.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getLoanCollections = async (id) => {
    try {
      const token = getSecureItem("token");
      const { data } = await Axios.get(
        `${BaseUrl}/loanCollection/getLoanCollectionByLoanId/?loanId=${id}`,
        { headers: { Authorization: "Bearer " + token } },
      );
      setLoanCollectionData(data?.data?.loanCollections || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getCompany = async () => {
    try {
      const compData = await getCompanyProfile();
      const {
        profilePic,
        companyName,
        GstIn,
        companyWebsite,
        phone,
        companyMail,
        AddressStreet,
        AddressLandmark,
        AddressCity,
        AddressState,
        AddressPincode,
      } = compData;
      setCompanyData({
        profilePic,
        companyName,
        GstIn,
        companyWebsite,
        phone,
        companyMail,
        address: {
          AddressStreet,
          AddressLandmark,
          AddressCity,
          AddressState,
          AddressPincode,
        },
      });
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    getCompany();
    getLoansSummary();
    fetchBranches();
  }, []);

  useEffect(() => {
    getLoansData();
    getLoansSummary();
  }, [page, loanTenure, datePickerM, endDateD, fullReport, selectedBranch]);

  useEffect(() => {
    if (!loanData?.length) {
      setSortedData([]);
      return;
    }
    let arr = [...loanData];
    if (sortConfig.key) {
      arr.sort((a, b) => {
        const aVal =
          sortConfig.key === "firstName"
            ? a?.customer?.[sortConfig.key]
            : sortConfig.key === "sourceName"
              ? a?.customer?.user?.firstName
              : a[sortConfig.key];
        const bVal =
          sortConfig.key === "firstName"
            ? b?.customer?.[sortConfig.key]
            : sortConfig.key === "sourceName"
              ? b?.customer?.user?.firstName
              : b[sortConfig.key];

        if (sortConfig.key === "date") {
          const da = moment(aVal, "DD/MM/YYYY"),
            db = moment(bVal, "DD/MM/YYYY");
          return sortConfig.direction === "asc" ? +da - +db : +db - +da;
        }
        if (typeof aVal === "number" && typeof bVal === "number")
          return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
        if (typeof aVal === "string" && typeof bVal === "string")
          return sortConfig.direction === "asc"
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        return 0;
      });
    }
    setSortedData(arr);
  }, [sortConfig, loanData]);

  useEffect(() => {
    if (!gotFullData) return;
    if (!sortedData.length) return;

    if (exportType === "pdf") {
      PdfReportDisburse({
        sortedData,
        totalAmtD: totalSummary?.totalLent,
        loanTenure,
        companyData,
      });
    }

    if (exportType === "excel") {
      const rows = sortedData.map((item) => ({
        "Loan ID": item.loanId,
        Borrower:
          `${item?.customer?.firstName ?? ""} ${item?.customer?.lastName ?? ""}`.trim() +
          (item?.customer?.cust_id ? ` (${item.customer.cust_id})` : "") +
          (item?.customer?.phone ? ` (${item.customer.phone})` : ""),
        "Area/Line": item?.customer?.areaLine ?? "",
        "Lent Amount": item.loanAmount,
        "Processing Fee": item.processFee,
        "Installment Amount": item.collectionAmount,
        "Approved Date": item.approvalDate
          ? moment(item.approvalDate).format("DD/MM/YYYY")
          : "",
        "Disbursed Date": item.disbursedDate
          ? moment(item.disbursedDate).format("DD/MM/YYYY")
          : "",
        "First Due Date": item.startDate
          ? moment(item.startDate).format("DD/MM/YYYY")
          : "",
        "Assigned To": item?.user
          ? `${item.user.firstName} ${item.user.lastName}`
          : "",
      }));
      ExcelReport({
        data: rows,
        fileName: "disburse_report.xlsx",
        sheetName: "Disburse Report",
        columnWidths,
      });
    }

    setTimeout(() => {
      setExportType(null);
      setFullReportSync(false);
      setGotFullData(false);
    }, 100);
  }, [gotFullData]);

  const handlePdfClick = () => {
    setExportType("pdf");
    setFullReportSync(true);
  };
  const handleExcelClick = () => {
    setExportType("excel");
    setFullReportSync(true);
  };

  const handleChangeSequence = (event, val) => {
    setPage(1);
    setLoanTenure(val);
  };
  const handlePageChange = (event, newPage) => setPage(newPage);

  const handleCustomDateRange = (details) => {
    if (details) {
      const dateRange = Object.values(details);
      setStartDateD(moment(dateRange[0]).format("DD MMM YYYY HH:mm:ss"));
      setEndDateD(moment(dateRange[1]).format("DD MMM YYYY HH:mm:ss"));
      setDatePickerM(false);
    }
  };

  const handleReset = () => {
    setDatePickerM(false);
    setStartDateD(null);
    setEndDateD(null);
    setLoanTenure("All");
    setSelectedBranch(null);
    handleCloseFilter();
    getLoansData();
    getLoansSummary();
  };

  const SequenceFilter = [
    { value: "onetime", label: "Onetime" },
    { value: "daily", label: "Daily" },
    ...(getSecureItem("loggedinUserCompany") == 2891
      ? [{ value: "ten_daily", label: "Ten_Daily" }]
      : []),
    { value: "weekly", label: "Weekly" },
    { value: "biweekly", label: "Bi-Weekly" },
    { value: "monthly", label: "Monthly" },
    { value: "All", label: "All" },
  ];

  return (
    <>
      <Sidebar />
      <div style={{ marginLeft: "73px", height: "100vh" }}>
        {loading ? (
          <div
            style={{ display: "flex", justifyContent: "center", marginTop: 10 }}
          >
            <CircularProgress />
          </div>
        ) : (
          <Grid container direction="column">
            <Grid item sx={{ backgroundColor: "#fff" }}>
              <div style={{ margin: 5 }}>
                <img src={companylogo} width={200} height={40} alt="logo" />
              </div>
            </Grid>

            <Grid
              container
              spacing={3}
              paddingX={4}
              paddingY={2}
              alignItems="center"
            >
              <Grid item xs={12} md={4}>
                <ToggleButtonGroup
                  color="primary"
                  value={loanTenure}
                  exclusive
                  onChange={handleChangeSequence}
                  size="small"
                >
                  {SequenceFilter.map((f, i) => (
                    <ToggleButton key={i} value={f.value}>
                      {f.label}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </Grid>
              <Grid item xs={12} md={4}>
                <Select
                  options={branchData}
                  isDisabled={(loggedinUser?.company?.planId == 3) ? false : true}
                  value={selectedBranch}
                  onChange={(val) => setSelectedBranch(val)}
                  placeholder="Select Branch"
                />
              </Grid>
              <Grid item xs={12} md={4} style={{ textAlign: "right" }}>
                <Button
                  id="filter-button"
                  onClick={handleClickFilter}
                  variant="outlined"
                  endIcon={<FilterAlt />}
                  aria-controls={openFilter ? "filter-basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openFilter ? "true" : undefined}
                >
                  Filter
                </Button>
              </Grid>
            </Grid>

            <strong
              style={{
                textAlign: "center",
                fontFamily: "Lato",
                marginTop: 10,
                fontSize: 18,
              }}
            >
              Disbursement Report
            </strong>

            <Grid container spacing={3} padding={4}>
              <Grid container spacing={3} paddingX={4} paddingTop={2}>
                {[
                  {
                    label: "Total Repayable",
                    value: totalSummary?.totalAmountToCollect,
                  },
                  { label: "Total Lent", value: totalSummary?.totalLent },
                  {
                    label: "Total Processing Fee",
                    value: totalSummary?.totalProcessFee,
                  },
                  {
                    label: "Total Interest",
                    value: totalSummary?.totalInterest,
                  },
                ].map(({ label, value }) => (
                  <Grid item xs={12} sm={6} md={3} key={label}>
                    <Card elevation={3} sx={{ borderRadius: 3 }}>
                      <CardContent>
                        <div style={{ fontSize: 22, fontWeight: 600 }}>
                          {value ?? "—"}
                        </div>
                        <div
                          style={{ fontSize: 14, color: "#666", marginTop: 4 }}
                        >
                          {label}
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              <Menu
                id="filter-basic-menu"
                anchorEl={anchorElFilter}
                open={openFilter}
                onClose={handleCloseFilter}
                MenuListProps={{
                  "aria-labelledby": "filter-button",
                  style: {
                    backgroundColor: "#2b3d63",
                    color: "#fff",
                    boxShadow: "#122344 1px 0px 5px 1px",
                  },
                }}
              >
                <MenuItem onClick={() => setDatePickerM(true)}>
                  Custom Date Range
                </MenuItem>
                <MenuItem onClick={handleReset}>Reset</MenuItem>
              </Menu>
            </Grid>

            {!loanId && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box paddingX={4} paddingY={2}>
                  <p className="Fonts">NOTE: Click on record to see details</p>
                </Box>
                <Box paddingX={4} paddingY={2}>
                  <Stack direction="row" alignItems="center" gap={2}>
                    <p className="Fonts">Download Reports:</p>
                    <img
                      src={pdf}
                      alt="pdf"
                      className="pdficon"
                      onClick={handlePdfClick}
                    />
                    <img
                      src={excel}
                      alt="excel"
                      className="excelicon"
                      onClick={handleExcelClick}
                    />
                  </Stack>
                </Box>
              </div>
            )}

            <Grid item container paddingX={4} paddingY={2}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }}>
                  <TableHead>
                    <TableRow>
                      {Object.keys(loanTableHeader).map((property) => (
                        <StyledTableCell key={property}>
                          <TableSortLabel
                            active={sortConfig.key === property}
                            direction={
                              sortConfig.key === property
                                ? sortConfig.direction
                                : "asc"
                            }
                            onClick={() => handleSortNew(property)}
                          >
                            {loanTableHeader[property]}
                          </TableSortLabel>
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortedData.map((data, index) => (
                      <StyledTableRow
                        key={index}
                        onClick={() => {
                          setCollectionModal(true);
                          setLoanId(data?.loanId);
                          setSelectedBorrower(
                            `${data?.customer?.firstName} ${data?.customer?.lastName}`,
                          );
                          getLoanCollections(data?.loanId);
                        }}
                      >
                        <StyledTableCell>{data?.loanId}</StyledTableCell>
                        <StyledTableCell>
                          <Stack>
                            <div>
                              {data?.customer?.firstName}{" "}
                              {data?.customer?.lastName}
                            </div>
                            {data?.customer?.cust_id && (
                              <div>({data.customer.cust_id})</div>
                            )}
                            {data?.customer?.phone && (
                              <div>({data.customer.phone})</div>
                            )}
                          </Stack>
                        </StyledTableCell>
                        <StyledTableCell>
                          {data?.customer?.areaLine}
                        </StyledTableCell>
                        <StyledTableCell>{data?.loanAmount}</StyledTableCell>
                        <StyledTableCell>{data?.processFee}</StyledTableCell>
                        <StyledTableCell>
                          {data?.collectionAmount}
                        </StyledTableCell>
                        <StyledTableCell>
                          {data?.approvalDate
                            ? moment(data.approvalDate).format("DD/MM/YYYY")
                            : ""}
                        </StyledTableCell>
                        <StyledTableCell>
                          {data?.disbursedDate
                            ? moment(data.disbursedDate).format("DD/MM/YYYY")
                            : ""}
                        </StyledTableCell>
                        <StyledTableCell>
                          {data?.startDate
                            ? moment(data.startDate).format("DD/MM/YYYY")
                            : ""}
                        </StyledTableCell>
                        <StyledTableCell>
                          {data?.user
                            ? `${data.user.firstName} ${data.user.lastName}`
                            : ""}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                variant="outlined"
                shape="rounded"
                size="large"
                style={{ marginTop: 10 }}
              />
            </Grid>
          </Grid>
        )}
      </div>

      <Dialog
        open={collectionModal}
        fullWidth
        maxWidth="lg"
        onClose={() => setCollectionModal(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {`Loan Collection Table | Borrower's Name: ${selectedBorrower}, Loan ID: ${loanId}`}
        </DialogTitle>
        <DialogContent>
          {loanId && (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }}>
                <TableHead>
                  <TableRow>
                    {Object.keys(collectionTableHeader).map((property) => (
                      <StyledTableCell key={property}>
                        <TableSortLabel
                          active={sortConfig.key === property}
                          direction={
                            sortConfig.key === property
                              ? sortConfig.direction
                              : "asc"
                          }
                          onClick={() => handleSortNew(property)}
                        >
                          {collectionTableHeader[property]}
                        </TableSortLabel>
                      </StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loanCollectionData.map((data, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell>{index + 1}</StyledTableCell>
                      <StyledTableCell>
                        {moment(data?.dueDate).format("DD/MM/YYYY")}
                      </StyledTableCell>
                      <StyledTableCell>{data?.openingBalance}</StyledTableCell>
                      <StyledTableCell>{data?.Installment}</StyledTableCell>
                      <StyledTableCell>{data?.closingBalance}</StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => setCollectionModal(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Customdaterange
        open={datePickerM}
        close={() => setDatePickerM(false)}
        isOnlyPast={true}
        save={handleCustomDateRange}
      />
    </>
  );
};

export default withNamespaces()(DisburseReport);
